import { handle } from "redux-pack";
import { KEY, LIFECYCLE } from "redux-pack";
import * as actionTypes from "../../constants/actionTypes";
import { handleDataStatus, initialDataStatus } from "./shared/dataStatus";

const status = (state = initialDataStatus, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PHONE_VARIANTS_DATA:
      return handleDataStatus(state, action);
    case actionTypes.INVALIDATE_PHONE_VARIANTS_DATA:
    case actionTypes.INVALIDATE_PORTAL_STATIC_DATA:
      return { ...state, didInvalidate: true };
    default:
      return state;
  }
};

const entities = (
  state = {
    byId: {},
    allIds: [],
    phoneOfferIds: [],
    propositionIds: []
  },
  action
) => {
  switch (action.type) {
    case actionTypes.LOAD_PHONE_VARIANT_DATA:
      if (action.payload !== undefined) {
        let phoneVariantKey;
        if (action.meta[KEY.LIFECYCLE] === LIFECYCLE.SUCCESS) {
          phoneVariantKey = Object.keys(
            action.payload.entities.phoneVariants
          )[0];
        }

        return handle(state, action, {
          success: prevState => ({
            ...prevState,
            byId: {
              ...prevState.byId,
              [phoneVariantKey]:
                action.payload.entities.phoneVariants[phoneVariantKey]
            },
            allIds: [...new Set([...prevState.allIds, action.payload.result])]
          })
        });
      } else {
        return state;
      }
    case actionTypes.LOAD_PHONE_VARIANTS_DATA:
      if (action.payload !== undefined) {
        return handle(state, action, {
          success: prevState => ({
            ...prevState,
            byId: action.payload.entities.phoneVariants || {},
            allIds: action.payload.result
          })
        });
      } else {
        return state;
      }
    case actionTypes.LOAD_PHONE_VARIANT_PHONE_OFFER_IDS_DATA:
      if (action.payload !== undefined) {
        return handle(state, action, {
          success: prevState => ({
            ...prevState,
            phoneOfferIds: action.payload
          })
        });
      } else {
        return state;
      }
    case actionTypes.LOAD_PHONE_VARIANT_PROPOSITION_IDS_DATA:
      if (action.payload !== undefined) {
        return handle(state, action, {
          success: prevState => ({
            ...prevState,
            propositionIds: action.payload
          })
        });
      } else {
        return state;
      }
    default:
      return state;
  }
};

export { entities, status };
